import { Route, Routes } from "react-router-dom";

import { LocaleRoute } from "@/components/core/locale-route";
import { NonLocaleRoute } from "@/components/core/non-locale-route";
import { RootRedirect } from "@/components/core/root-redirect";
import { LOCALES } from "@/i18n/types";
import { ContactPage } from "@/pages/contact-page";
import { ExperiencePage } from "@/pages/experience-page";
import { HomePage } from "@/pages/home-page";
import { LegalPage } from "@/pages/legal-page";
import { NotFoundPage } from "@/pages/not-found-page";
import { ProjectsPage } from "@/pages/projects-page";
import { SkillsPage } from "@/pages/skills-page";

export interface PrerenderRoute {
  locale: string;
  path: string;
}

export const PUBLIC_PAGES = [
  { path: "", title: "home" },
  { path: "experience", title: "experience" },
  { path: "projects", title: "projects" },
  { path: "skills", title: "skills" },
  { path: "contact", title: "contact" },
  { path: "legal", title: "legal" },
] as const;

export function getPrerenderRoutes(): PrerenderRoute[] {
  const routes: PrerenderRoute[] = [];
  for (const locale of LOCALES) {
    for (const { path } of PUBLIC_PAGES) {
      routes.push({
        locale,
        path: path ? `/${locale}/${path}` : `/${locale}`,
      });
    }
  }
  return routes;
}

export function AppRoutes(): JSX.Element {
  return (
    <Routes>
      <Route element={<RootRedirect />} path="/" />

      <Route element={<LocaleRoute />} path=":locale">
        <Route element={<HomePage />} index />
        <Route element={<ExperiencePage />} path="experience" />
        <Route element={<ProjectsPage />} path="projects" />
        <Route element={<SkillsPage />} path="skills" />
        <Route element={<ContactPage />} path="contact" />
        <Route element={<LegalPage />} path="legal" />
        <Route element={<NotFoundPage />} path="*" />
      </Route>

      <Route
        element={
          <NonLocaleRoute>
            <NotFoundPage />
          </NonLocaleRoute>
        }
        path="*"
      />
    </Routes>
  );
}
